export default function ColdDrinkIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#AECCCE"
        d="m7.939 3.27.811-.77v-.714h2.5V2.5l.811.77c.37.353.68.764.915 1.218v1.227H7.024V4.488c.236-.454.545-.865.915-1.218Z"
      />
      <path
        fill="#98B3B4"
        d="M12.061 3.27c.37.353.68.764.915 1.218v1.227h-.592a6.128 6.128 0 0 0-.301-1.227 4.872 4.872 0 0 0-.64-1.218l-.568-.77v-.714h.375V2.5l.811.77Z"
      />
      <path
        fill="#B7D2D3"
        d="M11.443 3.27c.27.374.485.784.64 1.218.142.397.244.808.302 1.227h-1.022c-.033-.412-.09-.822-.173-1.227a6.694 6.694 0 0 0-.366-1.218L10.5 2.5v-.714h.375V2.5l.568.77Z"
      />
      <path
        fill="#C7DCDD"
        d="m8.557 3.27.568-.77v-.714H9.5V2.5l-.324.77a6.7 6.7 0 0 0-.366 1.218c-.083.405-.14.815-.172 1.227H7.616c.058-.419.159-.83.301-1.227.155-.434.37-.844.64-1.218Z"
      />
      <path
        fill="#593434"
        d="M6.429 9.076c0-.323.128-.633.357-.862a1.033 1.033 0 0 1-.295-.858v-.718c.002-.75.184-1.487.533-2.15 1.322.112 1.442.866 2.976.866s1.654-.754 2.976-.867c.349.664.531 1.401.533 2.15v.719a1.032 1.032 0 0 1-.295.858c.229.229.357.539.357.862v5.776c0 .323-.128.633-.357.862.229.229.357.539.357.862v2.53c0 .494-.533.893-1.19.893a1.291 1.291 0 0 1-1.043-.462.18.18 0 0 0-.295 0 1.408 1.408 0 0 1-2.086 0 .18.18 0 0 0-.295 0A1.293 1.293 0 0 1 7.62 20c-.657 0-1.19-.4-1.19-.893v-2.531c0-.323.128-.633.357-.862a1.22 1.22 0 0 1-.357-.862V9.076Z"
      />
      <path
        fill="#432727"
        d="M12.456 6.638a6.31 6.31 0 0 0-.312-1.957c.266-.107.546-.172.832-.194.349.664.532 1.401.533 2.15v.719a1.032 1.032 0 0 1-.295.858c.229.229.358.539.358.862v5.776c0 .323-.129.633-.358.862.229.229.358.539.358.862v2.53c0 .494-.533.894-1.191.894a1.514 1.514 0 0 1-.413-.063.892.892 0 0 0 .532-.83v-2.53a1.523 1.523 0 0 0-.25-.863c.168-.256.255-.556.25-.862V9.076a1.523 1.523 0 0 0-.25-.862c.165-.254.238-.557.206-.858v-.718Z"
      />
      <path
        fill="#4F2C2C"
        d="M11.404 6.637c0-.515-.037-1.03-.11-1.54.295-.133.54-.292.85-.416.207.631.312 1.292.312 1.956v.718c.032.302-.041.605-.206.859.168.256.255.556.25.862v5.776c.005.306-.082.606-.25.862.168.256.255.556.25.862v2.53a.892.892 0 0 1-.532.831 1.17 1.17 0 0 1-.608-.377c.046-.147.07-.3.069-.453v-2.531a2.419 2.419 0 0 0-.143-.862c.1-.277.148-.569.143-.862V9.076a2.419 2.419 0 0 0-.143-.862c.097-.275.137-.567.118-.859v-.718Z"
      />
      <path
        fill="#7B5F5F"
        d="M7.5 16.576a1.523 1.523 0 0 1 .25-.862 1.523 1.523 0 0 1-.25-.863V9.076a1.523 1.523 0 0 1 .25-.862 1.325 1.325 0 0 1-.206-.859v-.718c0-.664.105-1.325.312-1.956.31.124.555.283.85.415a10.99 10.99 0 0 0-.11 1.541v.718c-.02.291.021.584.118.859-.1.276-.148.568-.143.862v5.775c-.005.294.044.586.143.863-.1.276-.148.568-.143.862v2.53c0 .154.023.307.069.454a.963.963 0 0 1-.237.21l-.062.037c-.097.056-.2.1-.309.13a.892.892 0 0 1-.532-.83v-2.531Z"
      />
      <path
        fill="#FF3B40"
        d="M11.25 1.786h-2.5a.179.179 0 0 1-.179-.178V.358A.357.357 0 0 1 8.93 0h2.142a.357.357 0 0 1 .358.358v1.25a.179.179 0 0 1-.179.178Z"
      />
      <path
        fill="#D5F3F6"
        d="M8.66 2.143h2.68a.179.179 0 0 0 0-.358H8.66a.179.179 0 0 0 0 .358Z"
      />
      <path
        fill="#EA243C"
        d="M11 1.636V.3A.299.299 0 0 0 10.701 0h.37a.357.357 0 0 1 .358.357v1.25a.179.179 0 0 1-.179.179h-.4a.149.149 0 0 0 .15-.15Z"
      />
      <path
        fill="#F42C3B"
        d="M10.571 1.673V.226A.227.227 0 0 0 10.345 0h.356A.299.299 0 0 1 11 .299v1.337a.15.15 0 0 1-.15.15h-.392a.113.113 0 0 0 .113-.113Z"
      />
      <path
        fill="#FF6C70"
        d="M9.299 0h.355a.226.226 0 0 0-.225.226v1.447a.113.113 0 0 0 .112.113H9.15A.15.15 0 0 1 9 1.636V.3A.299.299 0 0 1 9.299 0Z"
      />
      <path fill="#FF3B40" d="M13.571 14.821H6.43V9.107h7.142v5.714Z" />
      <path fill="#EA243C" d="M12.5 9.107h1.071v5.715H12.5V9.107Z" />
      <path fill="#F42C3B" d="M11.429 9.107H12.5v5.715h-1.071V9.107Z" />
      <path fill="#FF6C70" d="M7.5 9.107h1.072v5.715H7.5V9.107Z" />
      <path
        fill="#AECCCE"
        d="M10.759 11.465c1.858-.277 2.617.632 2.812.928v1.429a3.17 3.17 0 0 0-2.745-.87 7.223 7.223 0 0 1-4.397-.574v-1.912s2.27 1.306 4.33 1Z"
      />
      <path
        fill="#98B3B4"
        d="M12.5 11.59c.433.146.808.427 1.071.801v1.429a3.053 3.053 0 0 0-1.071-.694V11.59Z"
      />
      <path
        fill="#B7D2D3"
        d="M12.5 13.127a3.134 3.134 0 0 0-1.071-.217v-1.495a3.12 3.12 0 0 1 1.07.176v1.536Z"
      />
      <path
        fill="#C7DCDD"
        d="M8.571 12.994a7.381 7.381 0 0 1-1.071-.21v-1.823c.35.136.708.251 1.071.343v1.69Z"
      />
    </svg>
  );
}
